module.exports = __webpack_public_path__ + "static/media/test2_1.f7b12132.png";